import {
    Dialog as DialogOrg,
    DialogActions,
    DialogContent,
    DialogTitle,
    Button,
    Typography,
    Breakpoint,
} from '@mui/material';

interface Props {
    title: string;
    children: any;
    open?: boolean;
    onClose?: () => void;
    maxWidth?: Breakpoint | false;
    textBtn?: string;
    onClickSecondBtn?: () => void;
    textSecondBtn?: string;
}

export const Dialog = ({
    open,
    onClose,
    title,
    children,
    maxWidth = 'md',
    textBtn = 'Cerrar',
    onClickSecondBtn,
    textSecondBtn,
}: Props) => {
    return (
        <DialogOrg
            open={Boolean(open)}
            onClose={onClose}
            scroll="paper"
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
            fullWidth
            maxWidth={maxWidth}
        >
            <DialogTitle id="scroll-dialog-title">
                <Typography
                    sx={{
                        fontSize: { lg: 27, xs: 23 },
                        mt: { xs: 1.5, sm: 1.5, md: 1.5, lg: 0 },
                        color: 'primary.main',
                    }}
                >
                    {title}
                </Typography>
            </DialogTitle>
            <DialogContent dividers>{children}</DialogContent>
            <DialogActions>
                {onClickSecondBtn && (
                    <Button
                        style={{ color: 'primary.main' }}
                        onClick={onClickSecondBtn}
                    >
                        {textSecondBtn}
                    </Button>
                )}
                <Button style={{ color: 'primary.main' }} onClick={onClose}>
                    {textBtn}
                </Button>
            </DialogActions>
        </DialogOrg>
    );
};
